import { Col, InputNumber, Row, Slider } from 'antd';
import { SliderMarks } from 'antd/lib/slider';
import { noop } from 'lodash';
import React from 'react';

export type SliderWithInputProps = {
  max: number;

  /**
   * @default 0
   */
  min?: number;
  minmarks?: any;
  maxmarks?: any;

  contextmin?: number;
  contextmax?: number;

  onChange?: (value: number | '') => void;

  /**
   * @default 1
   */
  step?: number;

  /**
   * @default ''
   */
  value?: number | '';
  defaultValue?: number | '';
  precision: number;
  widthInput?: number;
  disabled?: boolean;
  gutter?: any;
  widthSlider?: any;
  classNameSlider?: string;
};

const SliderWithInput = ({
  max,
  min = 0,
  onChange = noop,
  step,
  minmarks,
  maxmarks,
  value = '',
  defaultValue = '',
  precision = 0,
  widthInput = 4,
  disabled,
  gutter,
  widthSlider,
  contextmin,
  contextmax,
  classNameSlider,
}: SliderWithInputProps) => {
  const handleChange = (value: any) => {
    onChange(typeof value === 'number' ? value : '');
  };

  const marks: SliderMarks = {
    [min]: {
      label: (
        <strong style={{ marginLeft: 15 }}>
          {Number(String(min)).toFixed(precision) !== 'NaN'
          && Number(String(min)).toFixed(precision)}
        </strong>
      ),
    },
    [contextmin ?? min]: {
      style: {
        color: 'red',
      },
      label: 
        <strong>
          {Number(String(contextmin ?? min)).toFixed(precision)}
        </strong>,
    },
    [contextmax ?? max]: {
      style: {
        color: 'red',
      },
      label: <strong>{Number(String(contextmax ?? max)).toFixed(precision)}</strong>,
    },
    [max]: {
      label: (
        <strong style={{ marginRight: 15 }}>
          {Number(String(max)).toFixed(precision) !== 'NaN'
          && Number(String(max)).toFixed(precision)}
        </strong>
      ),
    },
  };


  return (
    <Row gutter={gutter ?? [8, 8]} justify="space-between">
      <Col span={widthInput}>
        <InputNumber
          min={min}
          max={max}
          style={{ 
            width: '100%',
            position: 'absolute',
            zIndex: 1
           }}
          step={step}
          precision={precision}
          value={value as number}
          defaultValue={defaultValue as number}
          onChange={handleChange}
          disabled={disabled}
        />
      </Col>
      <Col span={24 - widthInput}>
        <Slider
          min={min}
          max={max}
          step={step}
          onChange={handleChange}
          style={{
            marginTop: 4,
            marginBottom: 16,
            width: widthSlider,
            position: 'relative',
            zIndex: 2,
            marginLeft: `calc(${widthInput}% + 10px)`,
          }}
          className={classNameSlider}
          value={typeof value === 'number' ? value : 0}
          disabled={disabled}
          marks={marks}
        />
      </Col>
    </Row>
  );
};

export default SliderWithInput;
